import React, { Component } from 'react';
import { getShowWOCancellationConfirmationModal } from '../../../../selectors/admin/work-orders/creation/creation';
import { cancelWorkOrderRequest } from '../../../../actions/admin/work-orders/work-orders';
import { closeWOCancellationModal } from '../../../../actions/admin/work-orders/creation/creation';
import { connect } from 'react-redux';
import { getCurrentWorkOrder } from '../../../../selectors/admin/work-orders/work-orders';
import ConfirmationModal from '../../../shared/modal/ConfirmationModal';

/**
 * Component to show and manage user decision for WO cancellation.
 */
class CancelWorkOrder extends Component {
  handleWOCancellationConfirmation = (result) => {
    if (result) {
      this.props.dispatch(
        cancelWorkOrderRequest(this.props.currentWorkOrder.id)
      );
    }
    this.props.dispatch(closeWOCancellationModal());
  };

  render() {
    return (
      <ConfirmationModal
        show={this.props.showWOCancellationConfirmationModal}
        message="Are you sure?"
        onHide={this.handleWOCancellationConfirmation}
      />
    );
  }
}

export default connect((state) => {
  return {
    currentWorkOrder: getCurrentWorkOrder(state),
    showWOCancellationConfirmationModal: getShowWOCancellationConfirmationModal(
      state
    ),
  };
})(CancelWorkOrder);



// WEBPACK FOOTER //
// ./src/components/admin/work-orders/creation/CancelWorkOrder.js